import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { ApiClientService } from '../services/generated/index';
import { FormService } from '../services/form.service';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { NgxGaugeModule } from 'ngx-gauge';
import { IonRangeSliderModule } from 'ng2-ion-range-slider';

import { AppComponent } from './app.component';
import { PublicformComponent } from './publicform/publicform.component';
import { SummaryComponent } from './summary/summary.component';
import { HeaderComponent } from './header/header.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { MinmaxvalidatorDirective } from './Validators/minmaxvalidator.directive';

import { GetText } from '../pipes/getText';
import { GetValueListItemText } from '../pipes/getValueListItemText';
import { GetPairText } from '../pipes/getPairText';
import { ToPercentagePipe } from '../pipes/to-percentage.pipe';
import { ToDateTimePipe } from '../pipes/to-date-time.pipe';

@NgModule({
  declarations: [
    AppComponent,
    PublicformComponent,
    SummaryComponent,
    HeaderComponent,
    NotfoundComponent,
    MinmaxvalidatorDirective,
    GetText,
    GetValueListItemText,
    GetPairText,
    ToPercentagePipe,
    ToDateTimePipe,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NgxGaugeModule,
    IonRangeSliderModule,
    FileUploadModule,
    RouterModule.forRoot([
      {
        path: 'form/:guid/:allsteps/:template/:frame',
        component: PublicformComponent
      },
      { //old form url
        path: 'form/:guid/:version/:allsteps/:template/:frame',
        component: PublicformComponent
      },
      {
        path: 'respond/:guid/:allsteps/:template/:frame',
        component: PublicformComponent
      },
      {
        path: 'preview/:guid/:allsteps/:template/:frame',
        component: PublicformComponent
      },
      { //old preview url
        path: 'preview/:guid/:version/:allsteps/:template/:frame',
        component: PublicformComponent
      },
      {
        path: 'summary/:guid/:template/:frame',
        component: SummaryComponent
      },
      {
        path: '404',
        component: NotfoundComponent
      }
      ,
      { path: '**', redirectTo: '/404' }
    ])
  ],
  providers: [
    ApiClientService,
    FormService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/a/1/s/src/app/app.module.ts